<template>
    <div id="hello-world-wrapper">
      <div class="content">
        <h1>Hello, World Component!</h1>
        <div class="input-container">
          <label for="inputText">Enter Text Here</label>
          <input type="text" id="inputText" v-model="inputText" />
        </div>
        <button @click="fetchData">Hello, World</button>
        <div v-if="apiResponse" class="response-container">
          <p><strong>Firstname:</strong> {{ apiResponse.firstname }}</p>
          <p><strong>Lastname:</strong> {{ apiResponse.lastname }}</p>
          <p><strong>Age:</strong> {{ apiResponse.age }}</p>
        </div>
        <span v-if="error" class="error-message">{{ error }}</span>
      </div>
    </div>
</template>
  
<script>
import axios from 'axios';

export default {
  name: 'HelloWorldPage',
  data() {
    return {
      inputText: '',
      apiResponse: null,
      error: null,
    };
  },
  methods: {
    async fetchData() {
      this.error = null;
      this.apiResponse = null;
      
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/hello-world`,
          { text: this.inputText },  // Send as JSON
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        
        console.log("Fetch Data response:", response.data);
        this.apiResponse = response.data;
      } catch (error) {
        this.error = 'An error occurred while fetching data';
        if (error.response && error.response.status === 400) {
          this.error = 'Invalid input';
        }
        console.error("Error details:", error);
      }
    },
  },
};
</script>
  
<style scoped>
  #hello-world-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 20px;
    background-color: #f5f5f5;
  }
  
  .content {
    max-width: 400px;
    width: 100%;
    padding: 20px;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .input-container {
    margin-bottom: 15px;
  }
  
  .input-container label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
  }
  
  .input-container input {
    width: 100%;
    padding: 8px;
    border-radius: 3px;
    border: 1px solid #ccc;
    box-sizing: border-box;
  }
  
  button {
    padding: 10px 15px;
    background-color: #28a745;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
  }
  
  button:hover {
    background-color: #218838;
  }
  
  .response-container {
    margin-top: 15px;
  }
  
  .error-message {
    color: red;
    margin-top: 10px;
  }
</style>
  